const deepObjectMerge = (FirstOBJ, SecondOBJ) => { // 深度合并对象
    for (var key in SecondOBJ) {
        FirstOBJ[key] = FirstOBJ[key] && FirstOBJ[key].toString() === "[object Object]" ?
            deepObjectMerge(FirstOBJ[key], SecondOBJ[key]) : FirstOBJ[key] = SecondOBJ[key];
    }
    return FirstOBJ;
}

Object.deepMerge = function(obj1,obj2){
	return deepObjectMerge(obj1,obj2)
} 